
import * as dom from './../../modules/wpstg-dom-utils';

/**
 * Push File Selection
 */
export default class WpstgPushFileSelection {
  constructor(
      workflowSelector = '#wpstg-workflow',
      filesTabSelector = '#wpstg-scanning-files',
      dirSelector = '.wpstg-check-dir',
      wpstgObject = wpstg,
  ) {
    this.workflow = dom.qs(workflowSelector);
    this.filesTabSelector = filesTabSelector;
    this.filesTab = dom.qs(filesTabSelector);
    this.dirSelector = dirSelector;
    this.wpstgObject = wpstgObject;

    this.init();
  }

  addEvents() {
    dom.addEvent(this.workflow, 'change', this.filesTabSelector + ' ' + this.dirSelector, () => {
      this.countSelectedFiles();
    });
  }

  init() {
    this.addEvents();
  }

  countSelectedFiles() {
    const filesCount = this.filesTab.querySelectorAll(this.dirSelector + ':checked').length;
    const filesCountElement = dom.qs('#wpstg-files-count');
    if (filesCount === 0) {
      filesCountElement.classList.add('danger');
      filesCountElement.innerHTML = this.wpstgObject.i18n['noFileSelected'];
    } else {
      let themesCount = 0;
      let pluginsCount = 0;
      filesCountElement.classList.remove('danger');
      this.filesTab.querySelectorAll('.wpstg-dir:not(.wpstg-sub-dir)>.wpstg-expand-dirs').forEach((head) => {
        if (head.innerHTML === 'plugins') {
          pluginsCount = head.nextSibling.querySelectorAll(this.dirSelector + ':checked').length;
        }

        if (head.innerHTML === 'themes') {
          themesCount = head.nextSibling.querySelectorAll(this.dirSelector + ':checked').length;
        }
      });

      filesCountElement.innerHTML = this.wpstgObject.i18n['filesSelected'].replace('{t}', themesCount).replace('{p}', pluginsCount);
    }
  }
}
